import MyTabs from '../../../components/MyTabs';
import Team from './Team';
import Preface from './Preface'
import Venue from './Venue'
import Highlights from './Highlights'
import AboutUs from './AboutUs';
import IndianCompetitionJury from './IndianCompetitionJury';
import AsianArabCompetitionJury from './AsianArabCompetitionJury';
import FirstFeaturesCompetitionJury from './FirstFeaturesCompetitionJury';
import NetworkForPromotionOfAsianCinema from './NetworkForPromotionOfAsianCinema';
import Fipresci from './Fipresci';

const Introduction = ({ isEventExhibition }) => {

    const eventExhibitionTabs = [
        { id: "preface", title: "Preface", Component: Preface },
        { id: "team", title: "Team", Component: Team },
        { id: "venue", title: "Venue", Component: Venue },
        { id: "highlights", title: "Highlights", Component: Highlights },
    ]

    const eventFilmFestivalTabs = [
        { id: "preface", title: "Preface", Component: Preface },
        { id: "about-us", title: "About Us", Component: AboutUs },
        { id: "indian-competition-jury", title: "Indian Competition Jury", Component: IndianCompetitionJury },
        { id: "asian-arab-competition-jury", title: "Asian Arab Competition Jury", Component: AsianArabCompetitionJury },
        { id: "first-features-competition-jury", title: "First Features Competition Jury", Component: FirstFeaturesCompetitionJury },
        { id: "network-for-promotion-of-asian-cinema", title: "Network For Promotion Of Asian Cinema", Component: NetworkForPromotionOfAsianCinema },
        { id: "fipresci", title: "FIPRESCI", Component: Fipresci },
    ]

    return (
        <MyTabs list={isEventExhibition ? eventExhibitionTabs : eventFilmFestivalTabs} />
    )
};

export default Introduction;